/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Incidents API
 * AV Services Incidents management API
 * OpenAPI spec version: 1.0
 */

export type IncidentsControllerV2GetAvailableFiltersV2Params = {
  /**
   * UUID of the building (location) to scope floor/room options to
   */
  locationId?: string;
  /**
   * UUID of the floor to scope room options to
   */
  spaceId?: string;
};
